module.exports = __webpack_public_path__ + "img/classification4.61a247ca.png";